import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevron-double-left",
  "use": "icon-chevron-double-left-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 12\" id=\"icon-chevron-double-left\"><g transform=\"translate(-474 -2097)\"><path d=\"M6.061,12,4,10,8,6,4,2,6.061,0,12,6Z\" transform=\"translate(486 2109) rotate(180)\" fill=\"currentColor\" /><path d=\"M6.061,12,4,10,8,6,4,2,6.061,0,12,6Z\" transform=\"translate(496 2109) rotate(180)\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol